import axios from "axios";
import { cookieApi } from '../services/auth/cookieApi';

export const publicApi = cookieApi
publicApi.isCancel = axios.isCancel;

export const privateApi = cookieApi


